export const STRIPE_INPUT_STYLING = {
  base: {
    iconColor: '#aaa',
    color: '#555',
    fontFamily: "'Nunito', sans-serif",
    fontSize: '18px',
    '::placeholder': {
      color: '#a2a2ab',
    },
    ':-webkit-autofill': {
      color: '#00aaff', // Blue
    },
  },
  invalid: {
    // Red
    iconColor: '#e74c3c',
    color: '#e74c3c',
  },
};

export default STRIPE_INPUT_STYLING;
